import { Track } from "@models/track";
import Hls, { LoaderResponse } from "hls.js";
import IAudioAdapter from "./IAudioAdapter";

export default class HLSAdapter implements IAudioAdapter {
	private _mediaElement: HTMLAudioElement;
	private _audioContext: AudioContext;
	private _track?: Track;
	private _pitchShift: number;
	private _hls: Hls;
	private _hlsSuppored: boolean;

	constructor(mediaElement: HTMLAudioElement, audioContext: AudioContext, errorCallback?: (error: LoaderResponse) => void) {
		this._mediaElement = mediaElement;
		this._audioContext = audioContext;
		this._pitchShift = 0;
		this._hls = new Hls();
		this._hlsSuppored = Hls.isSupported();

		if (errorCallback) {
			this._hls.on(Hls.Events.ERROR, function (event, data) {
				const errorType = data.type;

				if (errorType === Hls.ErrorTypes.NETWORK_ERROR) {
					const { response } = data;
					if (response) { return errorCallback(response); }
				}
			});
		}
	}

	load(track: Track): Promise<unknown> {
		this.reset();
		this._track = track;
		if (!this._hlsSuppored) {
			return new Promise<void>((resolve, reject) => {
				if (track.stream_url) {
					this._mediaElement.src = track.stream_url;
					// const me = this._mediaElement;

					this._mediaElement.addEventListener("error", reject);
					this._mediaElement.addEventListener("loadedmetadata", function () {
						resolve();
						// me.play();
					});
				}
			});
		}

		return new Promise((resolve, reject) => {
			this._hls.once(Hls.Events.MANIFEST_PARSED, resolve);
			this._hls.once(Hls.Events.ERROR, reject);

			if (track.stream_url) {
				this._hls.loadSource(track.stream_url);
				this._hls.attachMedia(this._mediaElement);
				this._hls.startLoad();
			}

			this._mediaElement.playbackRate = this._pitchShift + 1;
		});
	}

	play(time: number) {
		this.setCurrentTime(time);
		return this._mediaElement.play();
	}

	pause() {
		try {
			this._mediaElement.pause();
		} catch {
			// Do Nothing...
		}
	}

	destroy() {
		this._hls.destroy();
	}

	addEventListener = (e: any, fn: any) => {
		this._mediaElement.addEventListener(e, fn);
	};

	setPitchShift(shift: number): void {
		this._pitchShift = shift;
		this._mediaElement.playbackRate = shift + 1;
	}

	setCurrentTime(time: number): void {
		this._mediaElement.currentTime = time;
	}

	getCurrentTime(): number {
		return this._mediaElement.currentTime;
	}

	setVolume(volume: number): void {
		this._mediaElement.volume = volume;
	}

	getVolume(): number {
		return this._mediaElement.volume;
	}

	getDuration(): number {
		return this._mediaElement.duration;
	}

	reset() {
		this.pause();
		this.setCurrentTime(0);
		this._hls.detachMedia();
		this._hls.stopLoad();
	}
}
